const today = () => {
    const d = new Date()
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, "0")
    const day = String(d.getDate()).padStart(2, "0")
    return `${day}/${month}/${year}`
}

const dateMask = "99/99/9999"

export const caracteristicasFields = [
    {
        key: "emissao",
        label: "ID Emissão",
        required: true,
        md: 4,
        inputProps: {readOnly: true},
    },
    {
        key: "dataReferencia",
        label: "Data Referência",
        required: true,
        md: 4,
        mask: dateMask,
        maskType: "date",
        minDate: "01/01/1900",
        defaultValue: today(),
    },
    {
        key: "cetip",
        label: "CETIP",
        required: true, md: 4,
        normalize: "uppercase",
        inputProps: {readOnly: true},
    },
    {
        key: "versaoDocumento",
        label: "Versão Documento",
        required: true,
        md: 4,
        maskType: "integer",
        inputProps: {
            maxLength: 4,
            readOnly: true
        },
        defaultValue: 0
    },
    {
        key: "indexador",
        label: "Indexador",
        required: true,
        md: 4,
        defaultValue: 'PRE',
    },
    {
        key: "tipoAtivo",
        label: "Tipo Ativo",
        type: "autoComplete",
        autoCompleteSource: "grupoAtivos",
        required: true,
        md: 4,
    },
    {
        key: "taxaJuros",
        label: "Taxa Juros",
        required: true,
        md: 4,
        type: "number",
        maskType: "decimal",
        inputProps: {
            step: "0.01",
        },
        defaultValue: 0,
    },
    {
        key: "liquidezDiaria",
        label: "Liquidez Diária",
        required: true,
        md: 4,
        maskType: "integer",
        defaultValue: 0,
    },
]